export const price = [
  {
    low: 10000,
    high: 20000,
  },
  {
    low: 20000,
    high: 30000,
  },
  {
    low: 30000,
    high: 40000,
  },
  {
    low: 40000,
    high: 50000,
  },
];
